<template>
	<AuthShell>
		<Login />
	</AuthShell>
</template>

<script>
import Login from '@/modules/auth/components/Login'
import AuthShell from '@/modules/auth/components/AuthShell'

export default {
	components: {
		Login,
		AuthShell
	}
}
</script>
